module.exports = __webpack_public_path__ + "img/broken-image-icon.74c74d72.png";